import React, { useState } from 'react';
import { gql } from '@apollo/client';
import { Input } from 'antd';
import Page from 'components/Page';
import Table from 'components/Table';
import CopyToClipboardButton from 'components/CopyToClipboardButton';
import { useQuery } from 'hooks/apollo';
import useFormatMessage from 'hooks/useFormatMessage';
import globalMessages from 'translations/messages';

const QUERY = gql`
  query GetApiKeys {
    apiKeys {
      id
      createdAt
      lastUsedAt
      customer {
        id
        name
      }
    }
  }
`;

const ApiKeys = () => {
  const $t = useFormatMessage();
  const [search, setSearch] = useState();
  const { data, loading } = useQuery(QUERY);
  const columns = [
    {
      dataIndex: 'id',
      title: $t(globalMessages.key),
      render: (value) => (
        <Input.Password
          value={value}
          readOnly
          visibilityToggle
          addonAfter={(
            <CopyToClipboardButton textToCopy={value} type="text" size="small" hideTooltip />
          )}
        />
      ),
    },
    {
      dataIndex: 'createdAt',
      title: $t(globalMessages.created),
      type: 'datetime',
      defaultSortOrder: 'descend',
    },
    {
      dataIndex: 'lastUsedAt',
      title: 'Last used',
      type: 'datetime',
    },
    {
      dataIndex: ['customer', 'name'],
      title: $t(globalMessages.customers),
    },
  ];

  return (
    <Page>
      <Page.Header title="API keys" />
      <Page.Content>
        <Input.Search
          onSearch={setSearch}
          allowClear
          placeholder={$t(globalMessages.search)}
          style={{ marginBottom: '1em' }}
        />
        <Table
          loading={loading}
          columns={columns}
          dataSource={data?.apiKeys}
          search={search}
        />
      </Page.Content>
    </Page>
  );
};

export default ApiKeys;
